import { alpha, Chip, styled } from '@/shared/ui/mui';
/**
 * FeaturedChip - A purple chip/badge for featured items
 *
 * Features:
 * - Purple gradient background from theme
 * - White text
 * - Bold font weight
 * - Drop shadow with purple tint
 * - Perfect for "Featured", "Popular", "New" labels
 *
 * Usage:
 * ```tsx
 * <FeaturedChip label="Featured" />
 * <FeaturedChip label="Most Popular" />
 * ```
 */
export const FeaturedChip = styled(Chip)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  fontWeight: 'bold',
  boxShadow: `0 4px 8px ${alpha(theme.palette.primary.main, 0.3)}`,
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));
